// services/courseService.ts
import type { Course, Topic, Chapter } from '../types/course';

// Course data URL - hosted on the same domain, can be updated independently
// For production, this can point to a CDN or external JSON file
const COURSE_DATA_URL = import.meta.env.VITE_COURSE_DATA_URL || '/data/courses.json';

export const courseService = {
  async getAllCourses(): Promise<Course[]> {
    const url = `${COURSE_DATA_URL}${COURSE_DATA_URL.includes('?') ? '&' : '?'}t=${Date.now()}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Failed to fetch course data');
    }
    const data = await response.json();
    return Array.isArray(data) ? data : (data.courses || []);
  },

  async getCourseWithTopics(courseId: string): Promise<Course | null> {
    const courses = await this.getAllCourses();
    return courses.find(c => c.id === courseId) || null;
  },

  async getTopics(courseId: string): Promise<Topic[]> {
    const course = await this.getCourseWithTopics(courseId);
    return course?.topics || [];
  },

  async getTopicWithSubjects(topicId: string): Promise<Topic | null> {
    const courses = await this.getAllCourses();
    for (const course of courses) {
      const topic = course.topics?.find(t => t.id === topicId);
      if (topic) return topic;
    }
    return null;
  },

  async getChapterWithVideos(chapterId: string): Promise<Chapter | null> {
    const courses = await this.getAllCourses();
    for (const course of courses) {
      for (const topic of course.topics || []) {
        for (const subject of topic.subjects || []) {
          const chapter = subject.chapters?.find(c => c.id === chapterId);
          if (chapter) return chapter;
        }
      }
    }
    return null;
  },
};
